import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import LatestUpdates from './components/LatestUpdates';
import RankingSection from './components/RankingSection';
import CategorySection from './components/CategorySection';
import CTASection from './components/CTASection';

export default function Home() {
  const homeSchema = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '韩国漫画网 - 免费韩漫大全',
      description: '韩国漫画网提供免费韩漫大全在线阅读服务，与韩国同步更新最新漫画章节。海量正版韩漫资源，涵盖热血、恋爱、校园等多种类型。',
      url: 'https://www.manhuawang.cn',
      isPartOf: {
        '@type': 'WebSite',
        name: '韩国漫画网',
        url: 'https://www.manhuawang.cn',
      },
      primaryImageOfPage: {
        '@type': 'ImageObject',
        url: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20artistic%20illustration&width=1600&height=800&seq=hero-bg-korean-comic&orientation=landscape',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '韩国漫画网提供哪些类型的漫画？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '韩国漫画网提供热血、恋爱、校园、奇幻、悬疑、搞笑、动作、日常等丰富类型的韩国漫画，满足不同读者的阅读偏好。',
          },
        },
        {
          '@type': 'Question',
          name: '韩国漫画网的漫画是免费的吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '是的，韩国漫画网所有漫画均可免费在线阅读，无需付费订阅，无广告干扰，带来纯粹的阅读体验。',
          },
        },
        {
          '@type': 'Question',
          name: '韩国漫画网多久更新一次？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '韩国漫画网与韩国同步更新最新章节，每日都有多部热门漫画更新，确保读者第一时间看到最新内容。',
          },
        },
        {
          '@type': 'Question',
          name: '如何在韩国漫画网搜索漫画？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '您可以通过网站顶部的搜索框输入漫画名称或作者进行搜索，也可以通过分类页面按类型浏览所有漫画作品。',
          },
        },
      ],
    },
  ];

  return (
    <>
      <SEOHead
        title="韩国漫画网-免费漫画-韩漫大全-最新漫画在线阅读"
        description="韩国漫画网提供免费韩漫大全在线阅读服务，与韩国同步更新最新漫画章节。海量正版韩漫资源，涵盖热血、恋爱、校园等多种类型，支持在线阅读与离线下载，无广告畅快体验。"
        keywords="韩国漫画网,免费漫画,韩漫大全,最新漫画,在线阅读,漫画更新,韩漫推荐,热门韩漫,完结韩漫,韩国漫画在线"
        canonicalUrl="https://www.manhuawang.cn"
        ogTitle="韩国漫画网 - 免费韩漫大全 - 最新漫画在线阅读"
        ogDescription="海量正版韩国漫画免费在线阅读，每日同步更新最新章节，无广告畅快体验。"
        schemaJson={homeSchema}
      />
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <LatestUpdates />
          <RankingSection />
          <CategorySection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}